import { mapGetters, mapActions } from 'vuex';
import Titles from '@/components/Titles/index.vue';
import KickerWrapper from '@/components/KickerWrapper/index.vue';
import Kicker from '@/components/Kicker/index.vue';
import ProductAvailability from '@/components/ProductAvailability/index.vue';
import VatTooltip from '@/components/VatTooltip/index.vue';
import PriceWrapper from '@/components/PriceWrapper/index.vue';
import CtasWrapper from '@/components/CtasWrapper/index.vue';
import ProductFootnote from '@/components/ProductFootnote/index.vue';
import ColorPicker from '@/components/ColorPicker/index.vue';
import EmsFilters from '@/components/EmsFilters/index.vue';

export default {
  name: 'ProductInfo',
  components: {
    Titles,
    Kicker,
    KickerWrapper,
    ProductAvailability,
    PriceWrapper,
    CtasWrapper,
    ProductFootnote,
    ColorPicker,
    EmsFilters,
    VatTooltip,
  },
  data() {
    return {
      className: 'app__product__info',
      jsId: 'js__product__info',
    };
  },
  mounted() {
    this.callInterstitialAccessories();
  },
  watch: {
    partNumber() {
      this.callInterstitialAccessories();
    },
  },
  computed: {
    ...mapGetters({
      productName: 'getProductName',
      showProductName: 'getShowProductName',
      productVariation: 'getProductVariation',
      showProductVariation: 'getShowProductVariationName',
      partNumber: 'getPartNumber',
      showPartNumber: 'getShowPartNumber',
      showKicker: 'getShowProductKicker',
      kickerContent: 'getProductKickerContent',
      kickerText: 'getProductKickerText',
      price: 'getFormattedPrice',
      showPrice: 'getShowFormattedPrice',
      salePrice: 'getFormattedSalePrice',
      showSalePrice: 'getShowFormattedSalePrice',
      savings: 'getFormattedSavings',
      showSavings: 'getShowFormattedSavings',
      saveText: 'getPriceSaveText',
      shippingDisclaimer: 'getShippingDisclaimer',
      showShippingDisclaimer: 'getShowShippingDisclaimer',
      addToCartLoading: 'getAddToCartLoading',
      showBuyAction: 'getHasBuyAction',
      newBuyActionHref: 'getNewBuyActionHref',
      newBuyActionText: 'getNewBuyActionText',
      oldBuyActionHref: 'getOldBuyActionHref',
      oldBuyActionText: 'getOldBuyActionText',
      showDealerAction: 'getHasDealerAction',
      dealerActionHref: 'getDealerActionHref',
      dealerActionText: 'getDealerActionText',
      expressWarning: 'getExpressWarning',
      showExpressWarning: 'getShowExpressWarning',
      productHeaderDetails: 'getProductHeaderDetails',
      showProductHeaderDetails: 'getShowProductHeaderDetails',
      productAvailability: 'getProductAvailability',
      showProductAvailability: 'getShowProductAvailability',
      vatToolTip: 'getVatToolTip',
      showVatToolTip: 'getShowVatToolTip',
      productLegalText: 'getProductLegalText',
      showProductLegalText: 'getShowProductLegalText',
      productMarketingSummary: 'getProductMarketingSummary',
      showProductMarketingSummary: 'getShowProductMarketingSummary',
      showNewAddToCartBt: 'getShowNewAddToCartBt',
      showOldAddToCartBt: 'getShowOldAddToCartBt',
    }),
    kickerJsId() {
      return `${this.jsId}__kicker`;
    },
  },
  methods: {
    ...mapActions([
      'setAddToCartLoadingState',
      'callInterstitialAccessories',
    ]),
  },
};
